import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" };
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" };
const _hoisted_3 = { class: "d-flex align-items-center mt-10 mt-lg-0" };
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" };
const _hoisted_5 = {
    key: 0,
    class: "text-center py-5"
};
const _hoisted_6 = {
    key: 1,
    class: "table-responsive"
};
const _hoisted_7 = { class: "table text-nowrap align-middle mb-0" };
const _hoisted_8 = { class: "shadow-none lh-1 fw-medium text-muted" };
const _hoisted_9 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" };
const _hoisted_10 = { class: "d-block mb-1" };
const _hoisted_11 = { class: "text-muted d-block" };
const _hoisted_12 = { class: "text-muted" };
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" };
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" };
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-end pe-0" };
const _hoisted_16 = { class: "dropdown" };
const _hoisted_17 = { class: "dropdown-menu" };
const _hoisted_18 = ["onClick"];
const _hoisted_19 = ["onClick"];
const _hoisted_20 = ["onClick"];
const _hoisted_21 = ["onClick"];
const _hoisted_22 = { key: 1 };
const _hoisted_23 = {
    class: "modal fade",
    id: "traiteurViewModal",
    tabindex: "-1",
    "aria-hidden": "true"
};
const _hoisted_24 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_25 = { class: "modal-content border-0 rounded-1" };
const _hoisted_26 = {
    key: 0,
    class: "modal-body p-20"
};
const _hoisted_27 = { class: "mb-3 p-3 bg-light rounded-1 border" };
const _hoisted_28 = { class: "mb-0 text-black-emphasis" };
const _hoisted_29 = { class: "row g-2 small" };
const _hoisted_30 = { class: "col-6" };
const _hoisted_31 = { class: "fw-bold" };
const _hoisted_32 = { class: "modal-footer" };
const _hoisted_33 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "d-sm-flex align-items-center" }, [
                _createElementVNode("h5", { class: "card-title fw-bold mb-0 me-20" }, "Demandes Traiteur & Événements")
            ], -1)),
            _createElementVNode("div", _hoisted_3, [
                _withDirectives(_createElementVNode("select", {
                    class: "form-select shadow-none rounded-0 me-15",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.filterStatus) = $event))
                }, [...(_cache[1] || (_cache[1] = [
                        _createStaticVNode("<option value=\"\">Tous les statuts</option><option value=\"PENDING\">En attente</option><option value=\"EMAIL_SENT\">Email Envoyé</option><option value=\"CONTACTED\">Contacté</option><option value=\"PROCESSED\">Confirmé</option><option value=\"CANCELLED\">Annulé</option>", 6)
                    ]))], 512), [
                    [_vModelSelect, _ctx.filterStatus]
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_4, [
            (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_LoaderComponent)
                ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("table", _hoisted_7, [
                        _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                                }, "Date Demande"),
                                _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                                }, "Client"),
                                _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                                }, "Événement"),
                                _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                                }, "Convives"),
                                _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                                }, "Statut"),
                                _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                                }, "Actions")
                            ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                            (_ctx.filteredRequests.length > 0)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.filteredRequests, (req) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: req.id
                                    }, [
                                        _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.formatDate(req.created_at)), 1),
                                        _createElementVNode("td", _hoisted_9, [
                                            _createElementVNode("span", _hoisted_10, _toDisplayString(req.fullName), 1),
                                            _createElementVNode("small", _hoisted_11, _toDisplayString(req.email), 1),
                                            _createElementVNode("small", _hoisted_12, _toDisplayString(req.phone), 1)
                                        ]),
                                        _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.formatDate(req.eventDate)), 1),
                                        _createElementVNode("td", _hoisted_14, _toDisplayString(req.guestsCount) + " pers. ", 1),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                                class: _normalizeClass(["badge", _ctx.getStatusClass(req.status)])
                                            }, _toDisplayString(_ctx.getStatusLabel(req.status)), 3)
                                        ]),
                                        _createElementVNode("td", _hoisted_15, [
                                            _createElementVNode("div", _hoisted_16, [
                                                _cache[6] || (_cache[6] = _createElementVNode("button", {
                                                    class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                                                    type: "button",
                                                    "data-bs-toggle": "dropdown"
                                                }, [
                                                    _createElementVNode("i", { class: "flaticon-dots" })
                                                ], -1)),
                                                _createElementVNode("ul", _hoisted_17, [
                                                    _createElementVNode("li", null, [
                                                        _createElementVNode("a", {
                                                            class: "dropdown-item d-flex align-items-center",
                                                            href: "javascript:void(0);",
                                                            onClick: ($event) => (_ctx.viewRequest(req))
                                                        }, [...(_cache[3] || (_cache[3] = [
                                                                _createElementVNode("i", { class: "flaticon-view lh-1 me-8" }, null, -1),
                                                                _createTextVNode(" Voir le message ", -1)
                                                            ]))], 8, _hoisted_18)
                                                    ]),
                                                    _cache[4] || (_cache[4] = _createElementVNode("li", null, [
                                                        _createElementVNode("hr", { class: "dropdown-divider" })
                                                    ], -1)),
                                                    _cache[5] || (_cache[5] = _createElementVNode("li", null, [
                                                        _createElementVNode("h6", { class: "dropdown-header" }, "Changer le statut")
                                                    ], -1)),
                                                    _createElementVNode("li", null, [
                                                        _createElementVNode("a", {
                                                            class: "dropdown-item",
                                                            href: "javascript:void(0);",
                                                            onClick: ($event) => (_ctx.updateStatus(req, 'CONTACTED'))
                                                        }, "📞 Contacté", 8, _hoisted_19)
                                                    ]),
                                                    _createElementVNode("li", null, [
                                                        _createElementVNode("a", {
                                                            class: "dropdown-item",
                                                            href: "javascript:void(0);",
                                                            onClick: ($event) => (_ctx.updateStatus(req, 'PROCESSED'))
                                                        }, "✅ Confirmé", 8, _hoisted_20)
                                                    ]),
                                                    _createElementVNode("li", null, [
                                                        _createElementVNode("a", {
                                                            class: "dropdown-item",
                                                            href: "javascript:void(0);",
                                                            onClick: ($event) => (_ctx.updateStatus(req, 'CANCELLED'))
                                                        }, "❌ Annulé", 8, _hoisted_21)
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ]));
                                }), 128))
                                : (_openBlock(), _createElementBlock("tr", _hoisted_22, [...(_cache[7] || (_cache[7] = [
                                        _createElementVNode("td", {
                                            colspan: "6",
                                            class: "text-center py-4 text-muted"
                                        }, "Aucune demande reçue.", -1)
                                    ]))]))
                        ])
                    ])
                ]))
        ]),
        _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "modal-header" }, [
                        _createElementVNode("h5", { class: "modal-title fw-bold" }, "Détail du message"),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn-close shadow-none",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        })
                    ], -1)),
                    (_ctx.selectedRequest)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                                _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block small text-muted mb-1 text-uppercase fw-bold" }, "Projet / Message", -1)),
                                _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.selectedRequest.message || 'Aucun message fourni.'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "col-6" }, [
                                    _createElementVNode("span", { class: "text-muted d-block" }, "Source"),
                                    _createElementVNode("span", { class: "fw-bold" }, "Formulaire Traiteur Web")
                                ], -1)),
                                _createElementVNode("div", _hoisted_30, [
                                    _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-muted d-block" }, "Restaurant ciblé", -1)),
                                    _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.getRestaurantName(_ctx.selectedRequest.restaurantId)), 1)
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_32, [
                        _cache[12] || (_cache[12] = _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-secondary rounded-0 px-4",
                            "data-bs-dismiss": "modal"
                        }, "Fermer", -1)),
                        (_ctx.selectedRequest)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: 'mailto:' + _ctx.selectedRequest?.email,
                                class: "btn btn-primary rounded-0 px-4"
                            }, " Répondre par email ", 8, _hoisted_33))
                            : _createCommentVNode("", true)
                    ])
                ])
            ])
        ])
    ]));
}
